import { useMutation } from '@tanstack/react-query';
import { fetchApi } from '@/std/api/fetchApi';
import { invalidateVariacaoQuery } from '../util/invalidateVariacaoQuery';

type ApiVariacaoInserirBody = {
    var_nome: string;
    var_descricao: string;
    var_cor: string;
    valor: { vrr_valor: string }[];
};

function apiVariacaoInserir(body: ApiVariacaoInserirBody) {
    return fetchApi({
        body,
        endpoint: 'Variacao/Inserir',
        method: 'post',
        schema: null,
    });
}

export function useMutationVariacaoInserir() {
    return useMutation({
        mutationFn: apiVariacaoInserir,
        onSuccess: invalidateVariacaoQuery,
    });
}
